@if (representatives) {
  <form class="representatives-form">
    @for (representative of representatives.controls; track representative.value.tax_number || representative.value.name; let i = $index) {
      <app-representative-form
        class="representative-form"
        [is_standalone]="representatives.length <= 1"
        [representative]="representative"
        [representativeTypes]="representativeTypes"
        [countries]="countries"
        [index]="index ? index + '.' + (i + 1) : '' + (i + 1)"
      ></app-representative-form>
    }
    @if (showAddRepresentativeButton) {
      <button
        payee-button
        class="add-rep"
        (click)="addJointRep()"
      >
        +
      </button>
    }
  </form>
}
